import React from "react";

type CardDetailModalProps = {
  card: any;
  onClose: () => void;
};

const CardDetailModal: React.FC<CardDetailModalProps> = ({ card, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-xs mx-2 flex flex-col items-center relative">
      <button
        className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center rounded-full bg-indigo-500 text-white shadow hover:bg-indigo-700 transition z-10"
        style={{ padding: 0 }}
        onClick={onClose}
        aria-label="Close"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      {card.image && (
        <img src={card.image} alt={card.name} className="w-32 h-44 object-contain mb-4 rounded" />
      )}
      <div className="font-bold text-lg text-indigo-700 mb-2">{card.name}</div>
      <div className="text-sm text-gray-500 mb-1">{card.set} #{card.number}</div>
      <div className="text-sm text-gray-500 mb-1">{card.rarity}</div>
      {card.assignedBinderId && card.binderName && (
        <div className="text-xs bg-indigo-100 text-indigo-700 px-2 py-1 rounded mb-2">
          In Binder: {card.binderName}
        </div>
      )}
      {card.tcgplayerUrl && (
        <a
          href={card.tcgplayerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition"
        >
          View on TCGPlayer
        </a>
      )}
    </div>
  </div>
);

export default CardDetailModal;